import { isStrictParameterCheckingEnabled } from "./form-flow-engine-initializer.js";
const supportedStringTypes = new Set(["string", "System.String", "System.Guid"]);
const supportedNumberTypes = new Set([
    "number",
    "System.Byte",
    "System.Int16",
    "System.Int32",
    "System.Int64",
    "System.Single",
    "System.Double",
    "System.Decimal",
]);
const supportedBooleanTypes = new Set(["boolean", "System.Boolean"]);
const supportedDateTypes = new Set(["Date", "System.DateTime", "System.DateTimeOffset"]);
export function validateVariables(variableCollectionName, variables, values) {
    if (!variables?.length) {
        if (values) {
            throw new Error(`[Form Flow Engine] Expected empty "${variableCollectionName}".`);
        }
        // no variables
        return;
    }
    else {
        if (!values) {
            throw new Error(`[Form Flow Engine] Expected non empty "${variableCollectionName}".`);
        }
    }
    for (const variable of variables) {
        if (variable.Name in values) {
            if (isStrictParameterCheckingEnabled()) {
                const value = values[variable.Name];
                validateType(variableCollectionName, variable, value);
            }
        }
        else {
            throw new Error(`[Form Flow Engine] Expected "${variableCollectionName}" to contain variable "${variable.Name}".`);
        }
    }
    // check if values contain extra variables we don't expect in the form flow
    const variableNames = variables.map((v) => v.Name);
    for (const value in values) {
        if (!variableNames.includes(value)) {
            throw new Error(`[Form Flow Engine] Extra value "${value}" does not match "${variableCollectionName}".`);
        }
    }
}
function validateType(variableCollectionName, variable, value) {
    // variables are allowed to be undefined or null
    if (value === undefined || value === null) {
        return;
    }
    switch (true) {
        case supportedStringTypes.has(variable.VariableTypeName):
            if (typeof value !== "string") {
                throwIncompatibleError("string");
            }
            return;
        case supportedNumberTypes.has(variable.VariableTypeName):
            if (typeof value !== "number") {
                throwIncompatibleError("number");
            }
            return;
        case variable.VariableTypeName === "bigint":
            if (typeof value !== "bigint") {
                throwIncompatibleError("bigint");
            }
            return;
        case supportedBooleanTypes.has(variable.VariableTypeName):
            if (typeof value !== "boolean") {
                throwIncompatibleError("boolean");
            }
            return;
        case supportedDateTypes.has(variable.VariableTypeName):
            if (!(value instanceof Date)) {
                throwIncompatibleError("Date");
            }
            return;
        case variable.VariableTypeName.startsWith("System.") || variable.VariableTypeName.startsWith("CargoWise."):
            // can be enhanced further to identify entities
            if (typeof value !== "object") {
                throwIncompatibleError("object");
            }
            return;
        default:
            // No supported conversion identified so let it pass as is
            return;
    }
    function throwIncompatibleError(expectedType) {
        throw new Error(`[Form Flow Engine] Expected "${variableCollectionName}" to contain value for "${variable.Name}" of type "${expectedType}" but received "${typeof value}" instead.`);
    }
}
